import React, { Component } from "react";
import {Modal, Card, Form, Button, Row, Col, Table, Alert, Tab, Tabs, InputGroup, OverlayTrigger, Tooltip, ListGroup, FormLabel, CardBody} from "react-bootstrap";
import CreatableSelect from 'react-select/creatable';
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { formatarValor, formatarValorAPI, tiposServicos } from '../../common/utils';
import AsyncSelect from 'react-select/async';
import ReactQuill from 'react-quill';
import Paginacao from '../../common/pagination';
import { FaEdit, FaTrash, FaStream, FaCheck, FaTimes } from "react-icons/fa";
import '../ProgramasV2/ProgramasEdit.module.css';

class ServicosProcedimentos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            servicos: [{ valor: '', limite_por_cpf: "", servico_procedimento_id: '', servico_procedimento_nome: '', estados_selecionados: '', estados_register: "", id: null,  limite_periodo: '' , limite_observacao: '' , show: false, focusServico: false, servicoSearchTimeout: null, estadosFocus: false, estadosSearchTimeout: null }],
            programa_id: this.props.programa_id,
            focusFormulario: false,
            erroLoadRegistro: '',
            servico_titulo: 'Adicionar Serviço/Procedimento',
            loading: false,
            page_numb: this.props.page_numb || 1,
            page_limit: this.props.page_limit || 10
        }
    }

    componentDidMount() {
        this.carregarServicosPrograma();
    }

    carregarServicosPrograma = async () => {
        if (this.state.programa_id) {
            try {
                // Faz a requisição assíncrona para carregar os serviços
                const response = await api.get(`/programas/servicos_procedimentos/?programa=${this.state.programa_id}&status=1&limit=200`);
    
                // Array de estados brasileiros
                const estadosBrasileiros = [
                    { value: 'AC', label: 'Acre' },
                    { value: 'AL', label: 'Alagoas' },
                    { value: 'AM', label: 'Amazonas' },
                    { value: 'AP', label: 'Amapá' },
                    { value: 'BA', label: 'Bahia' },
                    { value: 'CE', label: 'Ceará' },
                    { value: 'DF', label: 'Distrito Federal' },
                    { value: 'ES', label: 'Espírito Santo' },
                    { value: 'GO', label: 'Goiás' },
                    { value: 'MA', label: 'Maranhão' },
                    { value: 'MT', label: 'Mato Grosso' },
                    { value: 'MS', label: 'Mato Grosso do Sul' },
                    { value: 'MG', label: 'Minas Gerais' },
                    { value: 'PA', label: 'Pará' },
                    { value: 'PB', label: 'Paraíba' },
                    { value: 'PR', label: 'Paraná' },
                    { value: 'PE', label: 'Pernambuco' },
                    { value: 'PI', label: 'Piauí' },
                    { value: 'RJ', label: 'Rio de Janeiro' },
                    { value: 'RN', label: 'Rio Grande do Norte' },
                    { value: 'RS', label: 'Rio Grande do Sul' },
                    { value: 'RO', label: 'Rondônia' },
                    { value: 'RR', label: 'Roraima' },
                    { value: 'SC', label: 'Santa Catarina' },
                    { value: 'SP', label: 'São Paulo' },
                    { value: 'SE', label: 'Sergipe' },
                    { value: 'TO', label: 'Tocantins' },
                ];
    
                // Mapeia os dados da resposta para a estrutura esperada
                const servicosCarregados = response.data.results.map(servico => {
                    const servicoComEstados = {
                        id: servico.id,
                        valor: formatarValor(servico.valor),
                        limite_por_cpf: servico.limite_por_cpf,
                        servico_procedimento_id: servico.servico_procedimento_id,
                        servico_procedimento_nome: servico.dados_servico.nome,
                        limite_periodo : servico.limite_periodo,
                        limite_observacao: servico.limite_observacao,
                        estados_register: servico.estados_list, // Mantém a estrutura original
                    };
    
                    // Verifica se 'estados_list' existe e é um array
                    if (Array.isArray(servico.estados_list)) {
                        // Cria a propriedade 'estados_selecionados' no serviço como um objeto
                        const estados_selecionados = servico.estados_list.reduce((acc, estadoRegistro) => {
                            // Encontra o estado correspondente ao 'uf' no array 'estadosBrasileiros'
                            const estado = estadosBrasileiros.find(est => est.value === estadoRegistro.uf);
                            if (estado) {
                                // Adiciona a chave 'estado.value' com o valor 'estado.label' no objeto acumulador
                                acc[estado.value] = estado.label;
                            }
                            return acc; // Retorna o objeto acumulado
                        }, {});
    
                        // Adiciona o objeto 'estados_selecionados' ao serviço
                        servicoComEstados.estados_selecionados = estados_selecionados;
                    }
    
                    return servicoComEstados; // Retorna o serviço com os estados selecionados
                });
    
                // Atualiza o estado com os dados carregados
                this.setState({ servicos: servicosCarregados });
    
            } catch (error) {
                // Caso ocorra um erro durante a requisição, captura o erro e define uma mensagem adequada
                console.error('Erro ao carregar serviços:', error);
    
                let erro_msg = 'Erro ao carregar serviços do programa, tente novamente';
    
                if (error.response && error.response.status === 500) {
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }
    
                // Atualiza o estado com a mensagem de erro
                this.setState({
                    erroLoadRegistro: erro_msg,
                });
            }
        }
    };

    carregarServicos = async (inputValue, index) => {
        if(!this.state.servicos[index].focusServico) {
            return [];
        }
        try {
            // Realiza a primeira requisição para obter serviços do programa
            const responsePrograma = await api.get(`/servicos_procedimentos/?nome=${inputValue}&programa_id=${this.state.programa_id}&status=1&programa=${this.state.programa_id}`);
            const opcoesDoPrograma = responsePrograma.data.results;
    
            // Realiza a segunda requisição para obter todos os serviços disponíveis
            const responseTodos = await api.get(`/servicos_procedimentos/?nome=${inputValue}&status=1&`);
            const opcoes = responseTodos.data.results
                .filter(servico => !opcoesDoPrograma.some(opcao => opcao.id === servico.id)) // Filtra os serviços que já estão no programa
                .map(servico => ({
                    value: servico.id,
                    label: `${servico.nome} (#${servico.id})`,
                    valor: formatarValor(servico.valor)
                }));
    
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar serviços/procedimentos:', error);
            return [];
        }
    };

    salvarServico = (index) => {
        const servico = this.state.servicos[index];
        const url = servico.id ? `/programas/servicos_procedimentos/${servico.id}/` : '/programas/servicos_procedimentos/';
        const metodo = servico.id ? 'put' : 'post';
    
        const dadosServico = {
            status: true,
            valor: formatarValorAPI(servico.valor),
            limite_por_cpf: servico.limite_por_cpf,
            limite_observacao: servico.limite_observacao,
            limite_periodo: servico.limite_periodo,
            programa_id: this.state.programa_id,
            servico_procedimento_id: servico.servico_procedimento_id
        };

        if(servico.estados_register) {
            dadosServico['estados_register'] = servico.estados_register;
        }

        api({
            method: metodo,
            url: url,
            data: dadosServico,
        })
        .then(response => {
            // Se for um novo serviço, atualize o estado com a ID retornada pela API
            if (!servico.id) {
                this.setState(prevState => {
                    const servicosAtualizados = [...prevState.servicos];
                    servicosAtualizados[index].id = response.data.id;
                    return { servicos: servicosAtualizados };
                });
            }
            
            const MySwal = withReactContent(Swal)
            const textSwal = (servico.id) ? 'Serviço atualizado com sucesso' : 'Serviço cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o serviço, verifique os campos e tente novamente'; 
            let content = '';           

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'servico_procedimento_id') {
                        content += `<br>&bull; Serviço/Procedimento: ${value}`;
                    }
                    if(key == 'valor') {
                        content += `<br>&bull; Valor: ${value}`;
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
    }

    adicionarServico = () => {
        this.setState(prevState => ({
            servicos: [...prevState.servicos, { valor: '', servico_procedimento_id: '', servico_procedimento_nome: '', estados_register: '', estados_selecionados: '', limite_periodo: '' , limite_observacao: '' , focusServico: false, servicoSearchTimeout: null, estadosFocus: false, estadosSearchTimeout: null }],
        }));
    };

    enviaRegistroServico = (e, index) => {
        e.preventDefault();

        const formData = new FormData();

        this.setState({
            loading: true,
            servico_nomeHelper: "",
            servico_descricaoHelper: "",
            servico_tipoHelper: "",
            servico_valorHelper: "",
        });

        const valorFormatadoAPI = formatarValorAPI(this.state.servico_valor);

        //vererifica se é edição ou adição
        const url = (this.state.servico_id) ? '/servicos_procedimentos/'+this.state.servico_id+'/' : '/servicos_procedimentos/'
        const metodo = (this.state.servico_id) ? 'put' : 'post'

        formData.append('nome', this.state.servico_nome);
        formData.append('descricao', this.state.servico_descricao);
        formData.append('tipo', this.state.servico_tipo);
        formData.append('valor', valorFormatadoAPI);
        formData.append('programa_id', this.state.programa_id);

        //envia para api
        api({
            method: metodo,
            url: url,
            data: formData,
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = 'Serviço/Procedimento cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
            this.setState({
                loading: false,
                showModalServico: false,
            })
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o serviço/procedimento, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key === 'nome'){
                        this.setState({ nomeHelper: value })
                    }
                    if(key === 'descricao'){
                        this.setState({ descricaoHelper: value })
                    }
                    if(key === 'tipo'){
                        this.setState({ tipoHelper: value })
                    }
                    if(key === 'valor'){
                        this.setState({ valorHelper: value })
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    editaServico = (id) => {
        if(id){
            this.setState({
                servico_id: id,
                servico_titulo: 'Editando Serviço',
                loading: true,
            })

            //consulta os dados do programa na api
            api.get(`/servicos_procedimentos/${id}`)
            .then(response => {
                const dados = response.data;

                //preenche os inputs
                this.setState({
                    erroLoadRegistro: '',
                    servico_nome: dados.nome,
                    servico_descricao: dados.descricao,
                    servico_tipo: dados.tipo,
                    servico_valor: dados.valor,
                    loading: false,
                    showModalServico: true
                })
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar serviço/procedimento, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
    }

    removerServico = (index) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover serviço?',
            text: "Tem certeza que deseja remover este serviço/procedimento?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                const servico = this.state.servicos[index];

                if (servico.id) {

                    const url = `/programas/servicos_procedimentos/${servico.id}/`;
                    const metodo = 'put';
                
                    const dadosServico = {
                        status: false
                    };
                
                    api({
                        method: metodo,
                        url: url,
                        data: dadosServico,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Serviço removido com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.setState(prevState => ({
                            servicos: prevState.servicos.filter((_, i) => i !== index),
                        }));
                        
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover o serviço, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        servicos: prevState.servicos.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'O serviço foi removido.',
                        'success'
                    );
                }
            }
        });
    };

    carregarEstados = async (inputValue, index) => {

        if(!this.state.servicos[index].estadosFocus) {
            return [];
        }
        try {
            const estadosBrasileiros = [
                { value: 'AC', label: 'Acre' },
                { value: 'AL', label: 'Alagoas' },
                { value: 'AM', label: 'Amazonas' },
                { value: 'AP', label: 'Amapá' },
                { value: 'BA', label: 'Bahia' },
                { value: 'CE', label: 'Ceará' },
                { value: 'DF', label: 'Distrito Federal' },
                { value: 'ES', label: 'Espírito Santo' },
                { value: 'GO', label: 'Goiás' },
                { value: 'MA', label: 'Maranhão' },
                { value: 'MT', label: 'Mato Grosso' },
                { value: 'MS', label: 'Mato Grosso do Sul' },
                { value: 'MG', label: 'Minas Gerais' },
                { value: 'PA', label: 'Pará' },
                { value: 'PB', label: 'Paraíba' },
                { value: 'PR', label: 'Paraná' },
                { value: 'PE', label: 'Pernambuco' },
                { value: 'PI', label: 'Piauí' },
                { value: 'RJ', label: 'Rio de Janeiro' },
                { value: 'RN', label: 'Rio Grande do Norte' },
                { value: 'RS', label: 'Rio Grande do Sul' },
                { value: 'RO', label: 'Rondônia' },
                { value: 'RR', label: 'Roraima' },
                { value: 'SC', label: 'Santa Catarina' },
                { value: 'SP', label: 'São Paulo' },
                { value: 'SE', label: 'Sergipe' },
                { value: 'TO', label: 'Tocantins' },
            ];

            const opcoes = estadosBrasileiros.filter(estado => 
                estado.label.toLowerCase().includes(inputValue.toLowerCase())
            );
    
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar serviços/procedimentos:', error);
            return [];
        }
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        if(name == "servico_valor"){
            const valorFormatado = formatarValor(value);
            this.setState({ [name]: valorFormatado });
        } else {
            this.setState({ [name]: value });
        }
    };

    handleChangeTexto = (e, index) => {
        const { name, value } = e.target;
        const servicos = [...this.state.servicos];
        servicos[index] = {
            ...servicos[index],
            [name]: value ?? ''
        };
        this.setState({ servicos });
    };

    handleChangeServico = (index, event, fieldName, arrChild) => {
        const servicos = [...this.state.servicos];
        if(fieldName === "show"){
            servicos[index] = {
                ...servicos[index],
                show: !servicos[index].show,
            };
        }
        if (fieldName === 'servico_procedimento_id') {
            servicos[index] = { ...servicos[index], servico_procedimento_id: event.value, servico_procedimento_nome: event.label, valor: event.valor };
        } else if(fieldName === 'estados_selecionados'){

            event.forEach(estado => {
                servicos[index] = {
                    ...servicos[index],
                    estados_selecionados: {
                        ...servicos[index].estados_selecionados,
                        [estado.value]: estado.label
                    }
                };
            });

            event.forEach(estado => {
                const novoEstado = {
                    uf: estado.value,
                    novo: false,
                    novo_acm: false,
                    adequacao: false,
                    adequacao_acm: false,
                    renovacao: false,
                    renovacao_adm: false
                };

                // Verifique se 'estados_register' é um array. Se não for, inicialize como um array vazio
                if (!Array.isArray(servicos[index].estados_register)) {
                    servicos[index].estados_register = [];
                }

                // Encontre o índice do estado com a mesma sigla (uf) dentro de estados_register
                const estadoIndex = servicos[index].estados_register.findIndex(estadoRegistro => estadoRegistro.uf === estado.value);

                if (estadoIndex !== -1) {
                    // Se o estado já existir, substitui
                    //servicos[index].estados_register[estadoIndex] = novoEstado;
                } else {
                    // Caso não exista, adiciona o novo estado
                    servicos[index].estados_register.push(novoEstado);
                }
            });

            // Remover estados que não estão mais no 'event'
            const estadosEventValues = event.map(estado => estado.value);

            // Remover do 'estados_selecionados'
            servicos[index].estados_selecionados = Object.keys(servicos[index].estados_selecionados)
                .filter(key => estadosEventValues.includes(key))
                .reduce((acc, key) => {
                    acc[key] = servicos[index].estados_selecionados[key];
                    return acc;
                }, {});

            // Remover do 'estados_register'
            servicos[index].estados_register = servicos[index].estados_register.filter(estadoRegistro => 
                estadosEventValues.includes(estadoRegistro.uf)
            );
        } else if (fieldName == "estados_register"){
            // Atualiza o objeto `servicos[index]` de forma imutável
            // Atualizando servicos[index] (suponhamos que index = 0)
            servicos[index] = {
                ...servicos[index], // Mantém o conteúdo original de servicos[index]
                estados_register: servicos[index].estados_register.map((item, idx) =>
                    idx === Number(arrChild.index_child)
                        ? { ...item, [arrChild.campo]: arrChild.value } // Atualiza o campo 'novo' para true
                        : item // Mantém os outros itens inalterados
                )
            };
        } else if(fieldName === 'valor') {
            const { value } = event.target;
            servicos[index] = { ...servicos[index], valor: formatarValor(value) };
        }        
        else if(fieldName == 'padrao'){                           
            servicos[index] = { ...servicos[index], padrao: event.target.checked };
        }
        else {
            const { name, value } = event.target;
            servicos[index] = { ...servicos[index], [name]: value };            
        }
        this.setState({ servicos });

        //console.log(this.state.servicos);
    };


    render() {
        return (
            <>
            <Card className="cardDestaque">
                <Card.Body>                    
                    <Form onSubmit={this.enviaServicosPrograma}>
                        <h4>Serviços/Procedimentos do Programa</h4>
                        {this.state.servicos.map((servico, index) => (
                            <div key={index} className="row-list">
                                <Row>
                                    <Col sm={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Serviço</Form.Label>
                                            <Row>
                                                <Col sm={9} >
                                                    <AsyncSelect
                                                        key={this.state.servicos[index].focusServico}
                                                        loadOptions={(inputValue) => {
                                                            return new Promise((resolve) => {
                                                                clearTimeout(this.state.servicos[index].servicoSearchTimeout);
                                                                servico.servicoSearchTimeout = setTimeout(() => {
                                                                    resolve(this.carregarServicos(inputValue, index));
                                                                }, 700);
                                                            });
                                                        }}
                                                        onFocus={() => {
                                                            this.setState({
                                                                servicos: this.state.servicos.map((servico, i) => i === index ? { ...servico, focusServico: true } : servico)
                                                            });
                                                        }}
                                                        autoFocus={this.state.servicos[index].focusServico}
                                                        openMenuOnFocus={this.state.servicos[index].focusServico}
                                                        defaultOptions
                                                        name="servico_procedimento_id"
                                                        placeholder="Buscar serviço/procedimento..."
                                                        noOptionsMessage={() => "Nenhum serviço/procedimento encontrado"}
                                                        onChange={e => this.handleChangeServico(index, e, 'servico_procedimento_id')}
                                                        value={servico.servico_procedimento_id ? { value: servico.servico_procedimento_id, label: `${servico.servico_procedimento_nome} (#${servico.servico_procedimento_id})` } : null}
                                                    />
                                                <a className="btn btn-link btn-sm p-0 mt-2" onClick={(e) => this.editaServico(servico.servico_procedimento_id)}>Editar Serviço</a>
                                                </Col>
                                                
                                                <Col sm={3} >
                                                    <Button variant="dark" size="sm" onClick={(e) => this.setState({ showModalServico: true })}>
                                                        Novo Serviço
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Form.Group>
                                    </Col>
                                    <Col sm={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Valor</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="valor"
                                                value={servico.valor} 
                                                onChange={e => this.handleChangeServico(index, e, 'valor')}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Limite por CPF</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="limite_por_cpf"
                                                value={servico.limite_por_cpf} 
                                                onChange={e => this.handleChangeServico(index, e, 'limite_por_cpf')}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Limite por Período (dias)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="limite_periodo"
                                                value={servico.limite_periodo} 
                                                onChange={e => this.handleChangeServico(index, e, 'limite_periodo')}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Limite Observação</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                name="limite_observacao"
                                                value={servico.limite_observacao} 
                                                 onChange={(e) => this.handleChangeTexto(e, index)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Estados</Form.Label>
                                            <AsyncSelect
                                                key={this.state.servicos[index].estadosFocus}
                                                loadOptions={(inputValue) => {
                                                    return new Promise((resolve) => {
                                                        clearTimeout(this.state.servicos[index].estadosSearchTimeout);
                                                        servico.estadosSearchTimeout = setTimeout(() => {
                                                            resolve(this.carregarEstados(inputValue, index));
                                                        }, 700);
                                                    });
                                                }}
                                                onFocus={() => {
                                                    this.setState({
                                                        servicos: this.state.servicos.map((servico, i) => i === index ? { ...servico, estadosFocus: true } : servico)
                                                    });
                                                }}
                                                autoFocus={this.state.servicos[index].estadosFocus}
                                                openMenuOnFocus={this.state.servicos[index].estadosFocus}
                                                defaultOptions
                                                name="servico_estados"
                                                placeholder="Buscar estados..."
                                                noOptionsMessage={() => "Nenhum serviço/procedimento encontrado"}
                                                isMulti
                                                onChange={e => this.handleChangeServico(index, e, 'estados_selecionados')}
                                                value={servico.estados_selecionados ? 
                                                Object.keys(servico.estados_selecionados).map(uf => ({
                                                    value: uf, // 'uf' será o valor da sigla do estado
                                                    label: servico.estados_selecionados[uf] // 'label' será o nome do estado
                                                })) : null}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Row>
                                        <Col sm={12} className="divestados">   
                                            {Object.keys(servico.estados_selecionados).length > 0 && (
                                                <>
                                                    {Object.entries(servico.estados_selecionados).map(([sigla, nome]) => (
                                                        <>
                                                        <Card className="cardDestaque" key={sigla}>
                                                            <Card.Body>                    
                                                                <Form>
                                                                    <h4 title={!servico.show ? "Mostrar opções do estado!" : "Fechar opções dos estados!"} style={{cursor: "pointer"}} onClick={(e) => this.handleChangeServico(index, e, "show")}>Opções do estado: {nome} ({sigla})</h4>
                                                                    <Row>
                                                                        <Col sm={12} xs={12}>
                                                                            <Form.Group className="mb-3">
                                                                                    {Object.entries(servico.estados_register)
                                                                                    .filter(([newkey, estado]) => estado.uf === sigla)
                                                                                    .map(([newkey, estado]) => (  // Aqui é necessário usar key e estado
                                                                                        <div key={newkey}>
                                                                                            <Row>
                                                                                                <Col sm={2} xs={12}>
                                                                                                    <Form.Group className="mb-3">
                                                                                                        <Form.Label>Novo</Form.Label>
                                                                                                        <div>
                                                                                                            <Button 
                                                                                                                variant={estado.novo ? "success" : "outline-secondary"}
                                                                                                                onClick={(e) => this.handleChangeServico(index, e, "estados_register", {campo: "novo", index_child: newkey, value: true })}>
                                                                                                                Sim
                                                                                                            </Button>
                                                                                                            {' '}
                                                                                                            <Button 
                                                                                                                variant={!estado.novo ? "danger" : "outline-secondary"}
                                                                                                                onClick={(e) => this.handleChangeServico(index, e, "estados_register", {campo: "novo", index_child: newkey, value: false })}>
                                                                                                                Não
                                                                                                            </Button>
                                                                                                        </div>
                                                                                                    </Form.Group>
                                                                                                </Col>
                                                                                                <Col sm={2} xs={12}>
                                                                                                    <Form.Group className="mb-3">
                                                                                                        <Form.Label>Novo ACM</Form.Label>
                                                                                                        <div>
                                                                                                            <Button 
                                                                                                                variant={estado.novo_acm ? "success" : "outline-secondary"}
                                                                                                                onClick={(e) => this.handleChangeServico(index, e, "estados_register", {campo: "novo_acm", index_child: newkey, value: true })}>
                                                                                                                Sim
                                                                                                            </Button>
                                                                                                            {' '}
                                                                                                            <Button 
                                                                                                                variant={!estado.novo_acm ? "danger" : "outline-secondary"}
                                                                                                                onClick={(e) => this.handleChangeServico(index, e, "estados_register", {campo: "novo_acm", index_child: newkey, value: false })}>
                                                                                                                Não
                                                                                                            </Button>
                                                                                                        </div>
                                                                                                    </Form.Group>
                                                                                                </Col>
                                                                                                <Col sm={2} xs={12}>
                                                                                                    <Form.Group className="mb-3">
                                                                                                        <Form.Label>Adequação</Form.Label>
                                                                                                        <div>
                                                                                                            <Button 
                                                                                                                variant={estado.adequacao ? "success" : "outline-secondary"}
                                                                                                                onClick={(e) => this.handleChangeServico(index, e, "estados_register", {campo: "adequacao", index_child: newkey, value: true })}>
                                                                                                                Sim
                                                                                                            </Button>
                                                                                                            {' '}
                                                                                                            <Button 
                                                                                                                variant={!estado.adequacao ? "danger" : "outline-secondary"}
                                                                                                                onClick={(e) => this.handleChangeServico(index, e, "estados_register", {campo: "adequacao", index_child: newkey, value: false })}>
                                                                                                                Não
                                                                                                            </Button>
                                                                                                        </div>
                                                                                                    </Form.Group>
                                                                                                </Col>
                                                                                                <Col sm={2} xs={12}>
                                                                                                    <Form.Group className="mb-3">
                                                                                                        <Form.Label>Adequação ACM</Form.Label>
                                                                                                        <div>
                                                                                                            <Button 
                                                                                                                variant={estado.adequacao_acm ? "success" : "outline-secondary"}
                                                                                                                onClick={(e) => this.handleChangeServico(index, e, "estados_register", {campo: "adequacao_acm", index_child: newkey, value: true })}>
                                                                                                                Sim
                                                                                                            </Button>
                                                                                                            {' '}
                                                                                                            <Button 
                                                                                                                variant={!estado.adequacao_acm ? "danger" : "outline-secondary"}
                                                                                                                onClick={(e) => this.handleChangeServico(index, e, "estados_register", {campo: "adequacao_acm", index_child: newkey, value: false })}>
                                                                                                                Não
                                                                                                            </Button>
                                                                                                        </div>
                                                                                                    </Form.Group>
                                                                                                </Col>
                                                                                                <Col sm={2} xs={12}>
                                                                                                    <Form.Group className="mb-3">
                                                                                                        <Form.Label>Renovação</Form.Label>
                                                                                                        <div>
                                                                                                            <Button 
                                                                                                                variant={estado.renovacao ? "success" : "outline-secondary"}
                                                                                                                onClick={(e) => this.handleChangeServico(index, e, "estados_register", {campo: "renovacao", index_child: newkey, value: true })}>
                                                                                                                Sim
                                                                                                            </Button>
                                                                                                            {' '}
                                                                                                            <Button 
                                                                                                                variant={!estado.renovacao ? "danger" : "outline-secondary"}
                                                                                                                onClick={(e) => this.handleChangeServico(index, e, "estados_register", {campo: "renovacao", index_child: newkey, value: false })}>
                                                                                                                Não
                                                                                                            </Button>
                                                                                                        </div>
                                                                                                    </Form.Group>
                                                                                                </Col>
                                                                                                <Col sm={2} xs={12}>
                                                                                                    <Form.Group className="mb-3">
                                                                                                        <Form.Label>Renovação ACM</Form.Label>
                                                                                                        <div>
                                                                                                            <Button 
                                                                                                                variant={estado.renovacao_acm ? "success" : "outline-secondary"}
                                                                                                                onClick={(e) => this.handleChangeServico(index, e, "estados_register", {campo: "renovacao_acm", index_child: newkey, value: true })}>
                                                                                                                Sim
                                                                                                            </Button>
                                                                                                            {' '}
                                                                                                            <Button 
                                                                                                                variant={!estado.renovacao_acm ? "danger" : "outline-secondary"}
                                                                                                                onClick={(e) => this.handleChangeServico(index, e, "estados_register", {campo: "renovacao_acm", index_child: newkey, value: false })}>
                                                                                                                Não
                                                                                                            </Button>
                                                                                                        </div>
                                                                                                    </Form.Group>
                                                                                                </Col>
                                                                                            </Row>
                                                                                        </div>
                                                                                    ))}
                                                                            </Form.Group>
                                                                        </Col>
                                                                    </Row>
                                                                </Form>
                                                            </Card.Body>
                                                        </Card>
                                                        </>
                                                    ))}
                                                </>
                                                )}
                                        </Col>
                                    </Row>
                                </Row>
                                <Button variant="success" className="btn-sm" onClick={() => this.salvarServico(index)}><FaCheck className="me-1" /> Salvar Serviço</Button>&nbsp;&nbsp;
                                <Button variant="danger" className="btn-sm ms-2" onClick={() => this.removerServico(index)}><FaTimes className="me-1" /> Remover Serviço</Button>
                            </div>
                        ))}
                        <Button variant="secondary" onClick={this.adicionarServico}><FaStream /> Adicionar Serviço</Button>
                    </Form> 
                </Card.Body>                
            </Card>
            
            {/* Modal Serviços*/}
            <Modal size="lg" show={this.state.showModalServico} onHide={(e) => this.setState({showModalServico: false})}>
                <Modal.Header closeButton>
                    <Modal.Title>{this.state.servico_titulo}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={this.enviaRegistroServico}>
                        <Row>
                            <Col sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Nome</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        name="servico_nome" 
                                        required 
                                        placeholder="Nome" 
                                        value={this.state.servico_nome} 
                                        onChange={this.handleChange} 
                                    />
                                    <Form.Text id="formNomeHelpBlock" className="text-danger">
                                        {this.state.servico_nomeHelper}   
                                    </Form.Text>
                                </Form.Group>
                            </Col>
                            <Col sm={4} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Tipo</Form.Label>
                                    <Form.Control 
                                        as="select" 
                                        name="servico_tipo" 
                                        value={this.state.servico_tipo} 
                                        required 
                                        onChange={this.handleChange}
                                    >
                                        <option value="">Tipo</option>
                                        {Object.entries(tiposServicos).map(([sigla, nome]) => (
                                            <option key={sigla} value={sigla}>
                                                {nome}
                                            </option>
                                        ))}
                                    </Form.Control>
                                    <Form.Text id="formTipoHelpBlock" className="text-danger">
                                        {this.state.servico_tipoHelper}
                                    </Form.Text>
                                </Form.Group>
                            </Col>
                            <Col sm={2} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Valor</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="servico_valor"
                                        value={this.state.servico_valor ? formatarValor(this.state.servico_valor) : ''} 
                                        onChange={this.handleChange}
                                    />
                                    <Form.Text id="formEanHelpBlock" className="text-danger">
                                        {this.state.servico_valorHelper}
                                    </Form.Text>
                                </Form.Group>
                            </Col>
                            <Col sm={12} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Descrição</Form.Label>
                                    <Form.Control 
                                        as="textarea" 
                                        required 
                                        placeholder="Descrição" 
                                        name="servico_descricao"
                                        value={this.state.servico_descricao} 
                                        onChange={this.handleChange} 
                                        className="custom-textarea"
                                    />
                                    <Form.Text id="formDescricaoHelpBlock" className="text-danger">
                                        {this.state.servico_descricaoHelper}
                                    </Form.Text>
                                </Form.Group>
                            </Col>
                        </Row>
                        {this.state.erroLoadRegistro ? (
                            <Alert variant="warning">
                                
                            </Alert>
                        ) : (
                            ''
                        )}
                        <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                            {this.state.loading ? (
                                <span className="spinner-border spinner-border-sm"></span>
                            ) : (
                                <>
                                    <FaCheck className="me-1" /> Salvar
                                </>
                            )}
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
            </>
        );
    }
}

export default ServicosProcedimentos;

